// Service
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { comingSoonMixins } from "@/app/mixins/modules/coming-soon-mixins"

// Constants
import { STATUS_CODES } from "@/app/constants/constants"



export default {
	name: 'PuppyListTable',
	components: {},
	directive: {},
	filters: {},
	mixins: [
		tableMixins,
		toastMessageMixins,
		comingSoonMixins
	],
	props: {},
	data() {
		return {
			isAPILoading: false,
			maxLittersCount: 15,

			// table
			theads: [
				{
					name: "Puppy Name",
					searchLabel: "f_puppyName",
					sortLabel: "puppyName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 250px;"
				},
				{
					name: "Identifier",
					searchLabel: "f_identifier",
					sortLabel: "identifier",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 180px;"
				},
				{
					name: "Gender",
					searchLabel: "f_gender",
					sortLabel: "gender",
					hasGenderFilter: true,
					isDesc: false,
					style: "min-width: 200px;"
				},
				{
					name: "Collar Colour",
					hasSearch: true,
					searchLabel: "f_colour",
					sortLabel: "colour",
					isDesc: false,
					style: "min-width: 250px;"
				},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 120px; display: flex;" },
			],
			// Gender List
			genderList: [{
				value: "Male",
				name: "Male",
			},
			{
				value: "Female",
				name: "Female",
			}],
			selectGender: '',
			limit: 15,
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			currentTotalCount: 0,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},
			matingId: null,
			breederSysId: null,
		}
	},
	computed: {},
	watch: {
		selectGender() {
			this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
		},
		selectedDateOfBirth() {
			this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc)
		},
	},
	async created() {
		if (this.$route.params) {
			this.matingId = this.$route.params.matingId;
			this.breederSysId = this.$route.params.breederSysId;
			this.currentTotalCount = await this.getTableContent();
		}
	},
	methods: {
		async getTableContent(
			fromFilter = false,
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
		) {
			page = fromFilter ? 1 : this.page
			limit = this.maxLittersCount;
			return await this.getLitterPuppyList({ page, limit, sortBy, desc })

		},
		async getLitterPuppyList(queryParams) {
			this.isAPILoading = true

			if (this.columnsFilter) {
				if (this.columnsFilter.f_puppyName) {
					queryParams["f_puppyName"] = this.columnsFilter.f_puppyName
				}
				if (this.columnsFilter.f_identifier) {
					queryParams["f_identifier"] = this.columnsFilter.f_identifier
				}
				if (this.columnsFilter.f_colour) {
					queryParams["f_colour"] = this.columnsFilter.f_colour
				}
			}
			if (this.selectGender) {
				queryParams["f_gender"] = this.selectGender;
			}

			try {
				const response = await breedingManagementService.getLitterPuppyList(this.breederSysId, this.matingId, queryParams);

				if (response.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: response.data.data,
						paginationData: response.data.pagination,
					}

					this.totalCount = this.tableContent.paginationData.totalCount;

				} else {
					this.showAPIErrorToast(this.toastMessages.litters().ERROR_GET_LITTER_LIST, response)
				}

			} catch (err) {
				this.showGenericErrorToast()
			} finally {
				this.isAPILoading = false
			}

			return this.totalCount;
		},
		showLitterDetails(litterId, event) {
			if (!litterId) {
				return;
			}

			this.$router.push(`/breeder-management/breeder-edit-litter-component/${this.breederSysId}/${this.matingId}/${litterId}`);
		},
		deleteLitterDetails(data, event) {
			const { puppyName, id } = data;
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete this puppy record?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: 'Delete',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dd3333 !important',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						// API call for delete
						breedingManagementService.deleteLitterPuppy(this.breederSysId, id).then(res => {
							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast('Deleted!', `Puppy has been deleted successfully.`);
								// refresh table with filter
								this.getTableContent();
							} else {
								this.showAPIErrorToast(`Unable to delete ${puppyName}`, res);
							}
						});

						this.currentTotalCount -= 1; // decrease 1 to show "Add Litters" button if needed
					}
				});
				
		},
		capitalizeFirstLetter(word) {
			if (typeof word !== 'string' || word.length === 0) {
				return word;
			}
			return word.charAt(0).toUpperCase() + word.slice(1);
		},
	},
}